import { Modal } from "antd";
import React from "react";
import { upperCase } from "../../libs";

function TransferHistory({ props }) {
  const { isPayment, onClose, dataTransfer } = props;

  return (
    <Modal
      title={null}
      visible={isPayment}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={dataTransfer.payment_method_id !== 2 ? 400 : 500}
    >
      <div>
        <p className="colors-blue text-2xl mb-6 font-bold header-title-bold ">
          Informasi Pembayaran
        </p>
        {dataTransfer.payment_method_id !== 1 && (
          <div>
            <div>
              <div className="flex mb-3 justify-between ">
                <p className="header-content colors-gray text-sm lg:text-base">
                  Metode Pembayaran
                </p>
                <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                  {dataTransfer?.payment_method ?? "Transfer"}
                </p>
              </div>
              {dataTransfer.payment_method_id !== 3 && (
                <div>
                  <div className="flex mb-3 justify-between ">
                    <p className="header-content colors-gray text-sm lg:text-base">
                      Bank
                    </p>
                    <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                      {upperCase(dataTransfer?.transfer_bank ?? "Bank Mandiri")}
                    </p>
                  </div>

                  <div className="flex mb-3 justify-between ">
                    <p className="header-content colors-gray text-sm lg:text-base">
                      Nomor Rekening
                    </p>
                    <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                      {dataTransfer?.transfer_account ?? "Tidak Ada Nomor"}
                    </p>
                  </div>

                  <div className="flex mb-3 justify-between ">
                    <p className="header-content colors-gray text-sm lg:text-base">
                      Nama Rekening
                    </p>
                    <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                      {upperCase(
                        dataTransfer?.transfer_name ?? "Tidak Ada Nama"
                      )}
                    </p>
                  </div>
                </div>
              )}

              {dataTransfer.payment_method_id === 3 && (
                <div>
                  <p className="text-center header-content colors-blue text-base lg:text-2xl mt-4 font-semibold">
                    QRIS QR Code
                  </p>
                  <div className="flex justify-center">
                    <img
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/assets/image/img_empty.png"; // some replacement image
                      }}
                      src={
                        process.env.REACT_APP_BACKEND_URL +
                        "/storage/" +
                        dataTransfer.transfer_link
                      }
                      alt="img-media"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <div>
          <button
            onClick={onClose}
            className="btn-blue w-full p-3 mt-8 focus:outline-none"
          >
            <div className="text-white lg:text-lg">Tutup</div>
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default TransferHistory;
